import React from 'react';
import styled from 'styled-components';
import Particle from './Particle';

function ContactItem({ title, icon, cont1, cont2 }) {
  return (
    <ContactItemStyled>
      <div className="icon-container">
        <div className="left-content">{icon}</div>
        <Particle />
      </div>

      <div className="right-content">
        <h6>{title}</h6>
        <p>{cont1}</p>
        <p>{cont2}</p>
      </div>
    </ContactItemStyled>
  );
}

const ContactItemStyled = styled.div`
  padding: 1.5rem 2rem;
  background-color: var(--background-dark-grey);
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  &:not(:last-child) {
    margin-bottom: 2.5rem;
  }

  @media screen and (max-width: 578px) {
    display: block;
  }

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    .left-content {
      padding: 1.5rem;
      border: 1px solid var(--border-color);
      border-radius: 50px;
      font-size: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1.5rem;
      svg {
        font-size: 2.3rem;
      }
      @media screen and (max-width: 578px) {
        margin-bottom: 1.5rem;
        margin-right: 0;
      }
    }
  }

  .right-content {
    h6 {
      color: var(--white-color);
      font-size: 1.2rem;
      padding-bottom: 0.6rem;
    }
    p {
      padding: 0.1rem 0;
    }
    @media screen and (max-width: 578px) {
      text-align: center;
    }
  }
`;

export default ContactItem;
